import { IconButton } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';

export const useGetColumns = () => {
    const navigate = useNavigate();

    const handleViewPacient = (paciente) => {
        navigate(`/buscarPaciente/detalle/${paciente.idPaciente}`);
    }

    const columns = [
        {
            field: 'action',
            headerName: '',
            flex: 20,
            sortable: false,
            filterable: false,
            noPadding: true,
            minWidth: 35,
            maxWidth: 35,
            renderCell: (params) => {
                return (
                    <IconButton size='small' onClick={() => handleViewPacient(params.row)}>
                        <VisibilityIcon />
                    </IconButton>
                );
            }
        },
        {
            field: 'idPaciente',
            headerName: 'HC',
            flex: 100
        },
        {
            field: 'delegacion',
            headerName: 'Delegación',
            flex: 190
        },
        {
            field: 'estado',
            headerName: 'Estado',
            flex: 100
        },
        {
            field: 'tipoDocumento',
            headerName: 'Tipo Doc.',
            flex: 110
        },
        {
            field: 'numeroDocumento',
            headerName: 'N° Doc.',
            description: 'Número de documento del paciente',
            flex: 120
        },
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 160
        },
        {
            field: 'apellido',
            headerName: 'Apellido',
            flex: 130
        },
        {
            field: 'fechaNacimiento',
            headerName: 'F. Nacimiento',
            description: 'Fecha de nacimiento del paciente',
            type: 'date',
            flex: 130
        },
        {
            field: 'edad',
            headerName: 'Edad',
            flex: 90
        },
        {
            field: 'idCliente',
            headerName: 'ID Cliente',
            flex: 130
        },
        {
            field: 'cliente',
            headerName: 'Cliente',
            flex: 200
        },
        {
            field: 'numeroAfiliado',
            headerName: 'N° Afiliado',
            flex: 150
        },
        {
            field: 'codSAPPaciente',
            headerName: 'Cod.SAP Paciente',
            flex: 150
        },
    ]

    const configuratedColumns = generateColumnsDefaultConfiguration(columns, true);

    return configuratedColumns;
}